export type DateFilterOption =
  | 'now'
  | 'today'
  | 'thisWeek'
  | 'thisMonth'
  | 'lastThreeMonths'
  | 'custom';

export const dateFilterOptionLabels = {
  now: 'Now',
  today: 'Today',
  thisWeek: 'This week',
  thisMonth: 'This month',
  lastThreeMonths: 'Last 3 months',
  custom: 'Custom...',
};

export type DateSelectedFn = (
  selectedRange: DateFilterOption,
  dateISOString?: string,
) => void;
